/**
 * By receiving the expedient statuses, it returns the 'last passed status'
 *
 * @param statuses
 * @returns {null}
 */
export function getCurrentStatus(statuses) {
    let displayStatus = null;

    // We search for the last status with occur date (they come ordered)
    for (let i in statuses) {
        let status = statuses[i];

        if (status.date !== null) {
            displayStatus = status;
        }
    }

    return displayStatus;
}

/**
 * By receiving the expedient statuses, it returns true if the expedient has the status 'verdict'
 *
 * @param statuses
 * @returns {boolean}
 */
export function hasSentenceStatus(statuses) {
    const verdictStatuses = ['verdict', 'estimated_verdict_without_costs', 'dismissal_verdict'];

    // We search in the status if it has the status that is 'Sentence'
    for (let i in statuses) {
        let status = statuses[i];

        if (verdictStatuses.includes(status.name)) {
            return true;
        }
    }

    return false;
}
